import { pathBuilder } from 'config/paths/index';
import { root as featureRoot } from 'config/paths/digitalForms';

export const root = `${featureRoot}/requests`;
export default pathBuilder(root);
